import React from 'react'

export const EmployeeList = () => {
  return (
    <div className='bg-white pt-4' style={{ marginTop: "-14px" }}>EmployeeList</div>
  )
}